import { useMemo } from "react";
import './styles.scss'
import SuccessGreenIcon from "assets/icons/SuccessGreenIcon";
import WarningYellowIcon from "assets/icons/WarningYellowIcon";
import ErrorRedIcon from "assets/icons/ErrorRedIcon";

export interface CFDIXmlStatusLabelProps {
  description: string
  status: "ok" | "duplicated" | "error"
}

const CFDIXmlStatusLabel = (props: CFDIXmlStatusLabelProps) => {
  const { description, status } = props;

  const statusIcon = useMemo(() => {
    switch(status){
      case "ok":
        return <SuccessGreenIcon />
      case "duplicated":
        return <WarningYellowIcon />
      case "error":
        return <ErrorRedIcon />
      default:
        return <div></div>      
    }
  }, [status])

  return(
    <div className="cfdi-xml-status-label">
      <span>{description}</span>
      <div>{statusIcon}</div>
    </div>
  )
}

export default CFDIXmlStatusLabel;